<template>
  <form @submit.prevent="changeName">
    <modal-card
      :title="`Change ${isSelf ? 'your' : 'this user\'s'} name`"
      :processing="isProcessing"
    >
      <b-field label="Name">
        <b-input
          ref="name"
          v-model="form.name"
          type="text"
          placeholder="Enter name"
          :disabled="isProcessing"
        />
      </b-field>
      <button
        slot="footer"
        :class="{ 'is-loading': isProcessing }"
        :disabled="formIsDisabled"
        type="submit"
        class="button is-success"
      >
        Change name
      </button>
    </modal-card>
  </form>
</template>

<script>
export default {
  name: "ChangeNameModal",
  props: {
    userId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      isProcessing: false,
      form: {
        name: this.name
      }
    };
  },
  computed: {
    isSelf() {
      return this.$store.getters["auth/isCurrentUser"](this.userId);
    },
    formIsValid() {
      if (this.$_.isEmpty(this.form.name)) return false;
      if (this.form.name === this.name) return false;
      return true;
    },
    formIsDisabled() {
      return !this.formIsValid || this.isProcessing;
    }
  },
  mounted() {
    this.$nextTick(() => this.focusOnName());
  },
  methods: {
    focusOnName() {
      return (
        this.$refs.name && this.$refs.name.$el.querySelector("input").focus()
      );
    },
    changeName() {
      this.isProcessing = true;
      this.$store
        .dispatch("user/updateProfile", {
          userId: this.userId,
          payload: { name: this.form.name }
        })
        .then(() => {
          this.$emit("changed");
          this.$toast.open({
            message: `Name changed`
          });
        })
        .catch(error => {
          this.isProcessing = false;
          this.focusOnName();
          if (error && error.message) {
            this.$toast.open({
              message: `${error.message}`,
              type: "is-danger"
            });
          }
        });
    }
  }
};
</script>
